// extracted by mini-css-extract-plugin
export var animationContainer = "_nz-0";
export var footer = "_nz-1";
export var gray = "_nz-2";
export var lineItem = "_nz-3";
export var lineItemImage = "_nz-4";
export var lineItemInfo = "_nz-5";
export var lineItemText = "_nz-6";
export var lineItems = "_nz-7";
export var modalContent = "_nz-8";
export var options = "_nz-9";
export var orderName = "_nz-a";
export var refundAmount = "_nz-b";